"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
exports.__esModule = true;
exports.hoist = exports.cloneChildren = void 0;
var cloneChildren_1 = require("./cloneChildren");
__createBinding(exports, cloneChildren_1, "default", "cloneChildren");
var hoist_1 = require("./hoist");
__createBinding(exports, hoist_1, "default", "hoist");
//# sourceMappingURL=index.js.map